export default __webpack_public_path__ + "static/media/frame-warrior.a3330fcf.png";